import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from 'i18next';

import english from './locales/en.json';
import spanish from './locales/es.json';

export const PRODUCT_FINANCE_NAMESPACE = 'productFinance';
export const PRODUCT_FINANCE_LOCALES = ['es', 'en'] as const;

export type ProductFinanceLocale = (typeof PRODUCT_FINANCE_LOCALES)[number];

const resources: Readonly<
  Record<ProductFinanceLocale, Readonly<Record<string, string>>>
> = Object.freeze({ en: english, es: spanish });

for (const locale of PRODUCT_FINANCE_LOCALES) {
  i18n.addResourceBundle(
    locale,
    PRODUCT_FINANCE_NAMESPACE,
    resources[locale],
    true,
    true,
  );
}

export function resolveProductFinanceLocale(
  preference: string | null | undefined,
  browserLanguages: readonly string[] = getBrowserLanguages(),
): ProductFinanceLocale {
  const candidates = preference ? [preference] : browserLanguages;
  return candidates.some(language => language.toLowerCase().startsWith('es'))
    ? 'es'
    : 'en';
}

export function ProductFinanceI18nProvider({
  children,
}: Readonly<{ children: ReactNode }>) {
  return (
    <I18nextProvider i18n={i18n} defaultNS={PRODUCT_FINANCE_NAMESPACE}>
      {children}
    </I18nextProvider>
  );
}

export function getProductFinanceResources() {
  return resources;
}

function getBrowserLanguages(): readonly string[] {
  if (typeof navigator === 'undefined') {
    return ['en'];
  }
  return navigator.languages.length > 0
    ? navigator.languages
    : [navigator.language || 'en'];
}
